import { css, cx } from '@emotion/css';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Colors } from '../../styles/colors';
import { labelStyle } from '../../styles/text';
import { PowerIcon, WaterIcon } from '../../../shared/assets/icons';

export const PedestalLoadingState = (): JSX.Element => {
  return (
    <SkeletonTheme baseColor={Colors.SURFACE} highlightColor="#e6ecf1">
      <div className={content} aria-busy="true" aria-label="Loading pedestal">
        <div className={topContainerStyle}>
          <div className={textContainerStyle}>
            <span className={cx(labelStyle, titleStyle)}>ID</span>
            <Skeleton height={'2.375rem'} borderRadius={8} />
          </div>
          <div className={iconsContainerStyle}>
            <div className={iconRowStyle}>
              <PowerIcon />
              <Skeleton
                inline={true}
                height={'1.25rem'}
                width={'2rem'}
                borderRadius={6}
              />
            </div>
            <div className={iconRowStyle}>
              <WaterIcon />
              <Skeleton
                inline={true}
                height={'1.25rem'}
                width={'2rem'}
                borderRadius={6}
              />
            </div>
          </div>
        </div>

        {[0, 1].map((row) => (
          <div className={cx(containerStyle, row > 0 && marginTop)} key={row}>
            <div className={style}>
              <Skeleton height={'4.5rem'} borderRadius={12} />
            </div>
            <div className={style}>
              <Skeleton height={'4.5rem'} borderRadius={12} />
            </div>
          </div>
        ))}

        <div className={center}>
          <div className={separator} />
        </div>

        {[0, 1].map((row) => (
          <div className={cx(containerStyle, row > 0 && marginTop)} key={row}>
            <div className={style}>
              <Skeleton height={'4.5rem'} borderRadius={12} />
            </div>
            <div className={style}>
              <Skeleton height={'4.5rem'} borderRadius={12} />
            </div>
          </div>
        ))}
      </div>
    </SkeletonTheme>
  );
};
const content = css`
  padding: 1.5rem;
  padding-bottom: 7rem;
  max-width: 24rem;
  margin: 0 auto;
`;
const style = css`
  width: calc(50% - 0.5rem);
`;

const containerStyle = css`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const marginTop = css`
  margin-top: 1rem;
`;
const center = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.75rem 0;
`;
const separator = css`
  height: 2.5rem;
  width: 0;
  border-left: 2px dashed ${Colors.BORDER_STRONG};
`;

const topContainerStyle = css`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
`;
const titleStyle = css`
  color: ${Colors.TEXT_SECONDARY};
`;
const iconRowStyle = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.375rem;
`;
const iconsContainerStyle = css`
  width: 45%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
const textContainerStyle = css`
  width: 45%;
`;
